class Friends {
    remove(username) {
        app.ajax.delete('/services/user/friends', {'username': username}, (response) => {
            this.updateButtons(response.status);
            $(".friend[data-username='" + username + "']").hide(200, function () {
                $(this).remove();
            });
        });
    }

    requestFriendship(username) {
        app.ajax.post('/services/user/friends/request-friendship', {'username': username}, (response) => {
            this.updateButtons(response.status);
        });
    }

    cancelFriendrequest(username) {
        app.ajax.delete('/services/user/friends/delete-friend-request', {'username': username}, (response) => {
            this.updateButtons(response.status);
            let notify = $("#sent-requests notify");
            if (notify) {
                notify.html(parseInt(notify.html()) - 1);
                $(".friend-request-row[data-username='" + username + "']").hide(200, function () {
                    $(this).remove();
                });
            }
        });
    }

    declineFriendrequest(username) {
        app.ajax.delete('/services/user/friends/delete-friend-request', {
            'username': username,
            'decline': true
        }, (response) => {
            this.updateButtons(response.status);
            let notify = $("#incoming-requests notify");
            if (notify) {
                notify.html(parseInt(notify.html()) - 1);
                $(".friend-request-row[data-username='" + username + "']").hide(200, function () {
                    $(this).remove();
                });
            }
        });
    }

    approveFriendrequest(username) {
        app.ajax.post('/services/user/friends/approve-friend-request', {'username': username}, (response) => {
            this.updateButtons(response.status);
            let notify = $("#incoming-requests notify");
            if (notify) {
                notify.html(parseInt(notify.html()) - 1);
                $(".friend-request-row[data-username='" + username + "']").hide(200, function () {
                    $(this).remove();
                });
            }
        });
    }

    updateButtons(status) {
        $(".profile-subnav-navitem[data-status]").attr("data-status", status);
    }
}